export default "__VITE_ASSET__PA6n4XXC__"